/* @flow */

import popoverConfirmacao, { type ConteudoPopover } from './popover-confirmacao';

const TEXTAREA = '<textarea class="form-control" id="textarea-popover" maxlength="300"></textarea>';

const getOpcoes = (opcoes: ?ConteudoPopover): ConteudoPopover => Object.assign({}, opcoes, {
    texto: opcoes && opcoes.texto ? `${opcoes.texto}: ${TEXTAREA}` : TEXTAREA,
    timeout: 100000,
});

const popoverTextarea = (
    container: Element, opcoes: ?ConteudoPopover = {},
) => popoverConfirmacao(container, getOpcoes(opcoes))
    .then(() => {
        const input = document.getElementById('textarea-popover');
        return input instanceof HTMLTextAreaElement ? input.value : '';
    });

export default popoverTextarea;
